/* Dependencies */
import styled from 'styled-components';

/* Components */
import { Button } from 'lego-dist';

/* Images, Icons */
import { ReactComponent as DeleteIcon } from 'images/icons/roundX.svg';

export const Container = styled.div.attrs(() => ({ className: 'DeleteClassroomContainer' }))`
  height: calc(100vh - 60px);
  padding: 16px 16px 20px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${({ theme }) => theme.breakPoints.tablet} {
    height: auto;
    padding: 20px 20px 30px;
  }
`;

export const SuccessContainer = styled.div.attrs(() => ({ className: 'DeleteClassroomContainerSuccess' }))`
  height: auto;
  padding: 40px;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  &:not(:last-child) {
    margin-bottom: 40px;
  }
`;

export const Header = styled.div.attrs(() => ({ className: 'DeleteClassroomHeader' }))`
  color: #535353;
  font-size: 14px;
  font-weight: bold;
  margin-bottom: 20px;

  #deleteClassroomName {
    color: #0086D8;
  }

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const Warning = styled.div.attrs(() => ({ className: 'DeleteClassroomWarning' }))`
  color: #EF4B48;
  font-size: 14px;
  font-weight: bold;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const List = styled.ul.attrs(() => ({ className: 'DeleteClassroomList' }))`
  color: #535353;
  font-size: 14px;
  font-weight: bold;
  padding-left: 20px;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const Message = styled.div.attrs(() => ({ className: 'DeleteClassroomMessage' }))`
  color: #535353;
  font-size: 14px;

  ${({ theme }) => theme.breakPoints.tablet} {
    font-size: 16px;
  }
`;

export const BtnWrapper = styled.div.attrs(() => ({ className: 'DeleteClassroomButtons' }))`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  margin-top: 20px;
`;

export const Cancel = styled(Button).attrs(() => ({ className: 'DeleteClassroomCancelButton' }))`
  margin-right: 16px;
  width: 120px;
`;

export const Delete = styled(Button).attrs(() => ({ className: 'DeleteClassroomButton' }))`
  width: 120px;
`;

export const DeleteImg = styled(DeleteIcon).attrs(() => ({ className: 'DeleteClassroomImage' }))`
  height: 60px;
  width: 60px;

  margin-top: 20px;
  margin-bottom: 10px;

  & #fill {
    fill: #E02020;
  }

  & #x {
    fill: ${({ theme }) => theme.colors.white};
  }
`;
